// src/hooks/useBookingEvents.js
import { useEffect, useState, useCallback } from 'react';
import getPusher from './pusher';

export const useBookingEvents = (currentType, onNewBooking) => {
  const [isConnected, setIsConnected] = useState(false);
  const [lastEvent, setLastEvent] = useState(null);

  useEffect(() => {
    const pusher = getPusher();
    
    // الاشتراك في القناة العامة للسائقين
    const channel = pusher.subscribe('driver-bookings');
    
    // التحقق من الاتصال
    channel.bind('pusher:subscription_succeeded', () => {
      console.log('✅ Connected to driver-bookings channel');
      setIsConnected(true);
    });
    
    channel.bind('pusher:subscription_error', (error) => {
      console.error('❌ Subscription error:', error);
      setIsConnected(false);
    });

    // الاستماع لأحداث الموافقة على الطلبات
    const handleBookingApproved = (data) => {
      console.log('📦 New booking approved:', data);
      // تحديد نوع الطلب من البيانات
      const booking = data?.booking || data;
      
      if (!booking) {
        console.warn('⚠️ Received a booking event but data or data.booking is missing:', data);
        return;
      }

      setLastEvent(data);

      let bookingType = 'fast';
      
      if (booking.transport_type) {
        bookingType = booking.transport_type === 'car' ? 'cars' : 'furnitures';
      } else if (booking.fast_order === 1) {
        bookingType = 'fast';
      } else {
        bookingType = 'regular';
      }
      
      // إذا كان الطلب من نفس النوع الذي يشاهده المستخدم حالياً
      if (bookingType === currentType) {
        onNewBooking?.(booking);
      } else {
        console.log(`⚠️ Booking type ${bookingType} doesn't match current type ${currentType}`);
      }
    };
    
    channel.bind('booking-approved', handleBookingApproved);
    
    return () => {
      channel.unbind('booking-approved', handleBookingApproved);
      channel.unbind_all();
      pusher.unsubscribe('driver-bookings');
    };
  }, [currentType, onNewBooking]);
  
  return { isConnected, lastEvent };
};